export const parseVariables = (html) => {
    const dataIds = Array.from(new Set([...(html ? html.match(/data-id="([^"]+)"/g) : [])]));
    const variables = dataIds && dataIds.length > 0 ? dataIds.map(d => { return d.match(/data-id="([^"]+)"/)[1] }) : [];
    return variables;
}

export const variableToMention = (html, expr) => {
    if (!html) return html;
    const result = html.replace(expr, '<span class="dx-mention" spellcheck="false" data-marker="#" data-mention-value="$1" data-id="$1">&#xFEFF;<span contenteditable="false"><span>#</span>$1</span>&#xFEFF;</span>');
    return result;
}

export const mentionToVariable = (html, replace, expr) => {
    if (!html) return html;
    const result = html.replace(/<span class="dx-mention"[^>]*?>.*?<span contenteditable="false"><span>#<\/span>([^<]+)<\/span>.*?<\/span>/g, replace);
    return result;
}